import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Converts a number into its equivalent word representation in Indian style.
 * @param {number} num 
 * @returns {string}
 */
const numberToWords = (num) => {
    const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const inWords = (n) => {
        if ((n = n.toString()).length > 9) return 'overflow';
        let nArray = ('000000000' + n).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!nArray) return '';
        let str = '';
        str += nArray[1] != 0 ? (a[Number(nArray[1])] || b[nArray[1][0]] + ' ' + a[nArray[1][1]]) + ' Crore ' : '';
        str += nArray[2] != 0 ? (a[Number(nArray[2])] || b[nArray[2][0]] + ' ' + a[nArray[2][1]]) + ' Lakh ' : '';
        str += nArray[3] != 0 ? (a[Number(nArray[3])] || b[nArray[3][0]] + ' ' + a[nArray[3][1]]) + ' Thousand ' : '';
        str += nArray[4] != 0 ? (a[Number(nArray[4])] || b[nArray[4][0]] + ' ' + a[nArray[4][1]]) + ' Hundred ' : '';
        str += nArray[5] != 0 ? ((str != '') ? 'and ' : '') + (a[Number(nArray[5])] || b[nArray[5][0]] + ' ' + a[nArray[5][1]]) : '';
        return str;
    };

    const words = inWords(Math.floor(num));
    return words ? words + ' Only' : 'Zero Only';
};

/**
 * Generates and downloads a professional GST PDF invoice for a given order.
 * @param {Object} order - The order object containing details.
 */
export const downloadInvoice = async (order) => {
    // Create a hidden container for the invoice
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.style.width = '800px';
    container.style.padding = '10px'; 
    container.style.backgroundColor = '#fff';
    container.style.fontFamily = "'Arial', sans-serif";
    container.style.color = '#000';

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    };

    const formatPrice = (price) => (price || 0).toFixed(2);

    // Business Details
    const biz = {
        name: "NSO SERVICES PRIVATE LIMITED",
        address: "NEAR NEW COURT, GF-1 Sumitra Heights, KACHERY ROAD UDITNAGAR, ROURKELA, SUNDERGARH",
        email: "nsooptical@gmail.com",
        phone: "9938831038",
        gstin: "21AAGCN8284N1ZY"
    };

    const totalAmount = order.total || order.total_amount || 0;
    const taxRate = 18; 
    const taxableTotal = totalAmount / (1 + taxRate / 100);
    const totalTax = totalAmount - taxableTotal;
    const cgstTotal = totalTax / 2;
    const sgstTotal = totalTax / 2;

    const itemsHtml = (order.items || []).map((item, idx) => {
        const itemTotal = (item.price * item.quantity);
        const itemTaxable = itemTotal / (1 + taxRate / 100);
        const itemTax = itemTotal - itemTaxable;
        
        return `
            <tr style="font-size: 11px;">
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #000; padding: 5px;">${item.stock_no || ''}</td>
                <td style="border: 1px solid #000; padding: 5px;">${item.name}</td>
                <td style="border: 1px solid #000; padding: 5px;">${item.article || ''}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.hsn || ''}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">${item.quantity}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(itemTaxable)}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">9%</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(itemTax/2)}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">9%</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(itemTax/2)}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(itemTotal)}</td>
            </tr>
        `;
    }).join('');

    container.innerHTML = `
        <div style="border: 2px solid #000; padding: 0; min-height: 1000px; background: #fff;">
            <!-- Header Section -->
            <div style="text-align: center; border-bottom: 2px solid #000; padding: 15px 10px;">
                <h1 style="margin: 0; font-size: 20px; font-weight: 900;">${biz.name}</h1>
                <p style="margin: 5px 0; font-size: 12px; font-weight: 500;">${biz.address}</p>
                <p style="margin: 0; font-size: 12px; font-weight: 600;">
                    E-mail:${biz.email} Phone: ${biz.phone} &nbsp; GSTIN : ${biz.gstin}
                </p>
            </div>

            <!-- Client & Invoice Info -->
            <div style="display: flex; border-bottom: 1px solid #000;">
                <div style="flex: 1.5; border-right: 1px solid #000; padding: 8px; font-size: 13px; line-height: 1.5;">
                    <div style="display: flex; margin-bottom: 4px;"><span style="width: 100px;">Party Name:</span> <span style="flex: 1;">${order.customer?.name || order.user_name || 'Customer'}</span></div>
                    <div style="display: flex; margin-bottom: 4px;"><span style="width: 100px;">GSTN No.:</span> <span style="flex: 1;">${order.customer?.gstin || ''}</span></div>
                    <div style="display: flex;"><span style="width: 100px;">Address:</span> <span style="flex: 1;">${order.shipping_address?.address_line1 || order.shipping_address?.full_address || ''}</span></div>
                </div>
                <div style="flex: 1; padding: 8px; font-size: 13px; line-height: 1.5;">
                    <div style="display: flex; margin-bottom: 4px;"><span style="width: 110px;">Invoice Date :</span> <span>${formatDate(order.created_at)}</span></div>
                    <div style="display: flex; margin-bottom: 4px;"><span style="width: 110px;">Invoice Number :</span> <span>${String(order.order_id).padStart(6, '0')}</span></div>
                    <div style="display: flex;"><span style="width: 110px;">Order Number :</span> <span>${order.order_id}</span></div>
                </div>
            </div>

            <!-- Items Table -->
            <table style="width: 100%; border-collapse: collapse;">
                <thead>
                    <tr style="font-size: 10px;">
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 30px;">Sr. No.</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 60px;">Stock No</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px;">Item Description</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 60px;">Article</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 40px;">HSN</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 30px;">Qty</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 70px;">Taxable Value</th>
                        <th colspan="2" style="border: 1px solid #000; padding: 5px;">CGST</th>
                        <th colspan="2" style="border: 1px solid #000; padding: 5px;">SGST</th>
                        <th rowspan="2" style="border: 1px solid #000; padding: 5px; width: 80px;">Total</th>
                    </tr>
                    <tr style="font-size: 9px;">
                        <th style="border: 1px solid #000; padding: 3px; width: 30px;">%</th>
                        <th style="border: 1px solid #000; padding: 3px; width: 50px;">Amount</th>
                        <th style="border: 1px solid #000; padding: 3px; width: 30px;">%</th>
                        <th style="border: 1px solid #000; padding: 3px; width: 50px;">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    ${itemsHtml}
                    ${Array.from({ length: Math.max(0, 5 - (order.items?.length || 0)) }).map(() => `
                        <tr style="height: 25px;">
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000;"></td><td style="border: 1px solid #000;"></td>
                        </tr>
                    `).join('')}
                    <tr style="font-weight: bold; font-size: 11px;">
                        <td colspan="5" style="border: 1px solid #000; padding: 5px; text-align: right;">Total :</td>
                        <td style="border: 1px solid #000; padding: 5px; text-align: center;">${(order.items || []).reduce((acc, item) => acc + item.quantity, 0)}</td>
                        <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(taxableTotal)}</td>
                        <td style="border: 1px solid #000;"></td>
                        <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(cgstTotal)}</td>
                        <td style="border: 1px solid #000;"></td>
                        <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(sgstTotal)}</td>
                        <td style="border: 1px solid #000; padding: 5px; text-align: right;">${formatPrice(totalAmount)}</td>
                    </tr>
                </tbody>
            </table>

            <!-- Amount in words -->
            <div style="border-bottom: 2px solid #000; padding: 8px; font-size: 12px;">
                <div><strong>Amount Chargeable (in words) :</strong></div>
                <div style="font-weight: 600; margin-top: 4px;">${numberToWords(totalAmount)}</div>
            </div>

            <!-- Payment & Tax Section -->
            <div style="display: flex;">
                <div style="flex: 1.5; padding: 8px; border-right: 1px solid #000; font-size: 11px;">
                    <strong>Payment Detail</strong><br>
                    <table style="width: 70%; margin-top: 5px; border-collapse: collapse; border: 1px solid #000;">
                        <tr><td style="border: 1px solid #000; padding: 3px; width: 40%;">Value</td><td style="border: 1px solid #000; padding: 3px;">${formatPrice(totalAmount)}</td></tr>
                        <tr><td style="border: 1px solid #000; padding: 3px;">Method</td><td style="border: 1px solid #000; padding: 3px;">${order.payment_method?.toUpperCase() || 'ONLINE'}</td></tr>
                    </table>
                    <div style="margin-top: 15px; font-size: 10px; line-height: 1.4;">
                        1. This is a computer generated document and does not require any signature.<br>
                        2. All Items delivered with Case , Cloth & Carry bag<br>
                        3.All products are delivered from our outlet only.<br>
                        4. Subject to Rourkela Jurisdiction<br>
                        5. Add GST 18% charges
                    </div>
                </div>
                <div style="flex: 2; padding: 8px; font-size: 11px; text-align: right;">
                    <strong>Tax Details :</strong>
                    <table style="width: 100%; margin-top: 5px; border-collapse: collapse; border: 1px solid #000; text-align: center; font-size: 10px;">
                        <tr style="background: #fff;">
                            <th style="border: 1px solid #000; padding: 3px;">Value</th>
                            <th style="border: 1px solid #000; padding: 3px;">CGST %</th>
                            <th style="border: 1px solid #000; padding: 3px;">CGST Value</th>
                            <th style="border: 1px solid #000; padding: 3px;">SGST %</th>
                            <th style="border: 1px solid #000; padding: 3px;">SGST Value</th>
                            <th style="border: 1px solid #000; padding: 3px;">Total GST Value</th>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #000; padding: 3px;">${formatPrice(taxableTotal)}</td>
                            <td style="border: 1px solid #000; padding: 3px;">9%</td>
                            <td style="border: 1px solid #000; padding: 3px;">${formatPrice(cgstTotal)}</td>
                            <td style="border: 1px solid #000; padding: 3px;">9%</td>
                            <td style="border: 1px solid #000; padding: 3px;">${formatPrice(sgstTotal)}</td>
                            <td style="border: 1px solid #000; padding: 3px;">${formatPrice(totalTax)}</td>
                        </tr>
                    </table>
                    <div style="margin-top: 30px;">
                        <div style="font-weight: 800; font-size: 13px;">${biz.name}</div>
                        <div style="margin-top: 30px;">Authorosed Signatory</div>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(container);
    
    try {
        const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff'
        });
        
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const imgProps = pdf.getImageProperties(imgData);
        // Add a bit of margin for the PDF page
        const pdfHeight = (imgProps.height * (pdfWidth - 20)) / imgProps.width;
        
        pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth - 20, pdfHeight);
        pdf.save(`NSO-Invoice-${order.order_id}.pdf`);
    } catch (error) {
        console.error('Error generating PDF:', error);
        throw error;
    } finally {
        document.body.removeChild(container);
    }
};
